// extracted by mini-css-extract-plugin
export default {"filterContainer":"client-filter_filterContainer__Qmzac"};